<template>

  <div class="nps-score-container">

    <!-- Current Survey's NPS Score Card  -->
    <h4>{{ nps_answer_count }} Answers</h4>
    <div class="donut-container">
      <div class="nps-number-container">
        <p class="nps-number">{{ this.nps_score }}</p>
        <p class="nps-number-subtitle">NPS</p>
      </div>
      <NPSDoughnut :donut_values="this.nps_category_counts" />
    </div>
    <button class="chart-btn" @click="is_modal_visible = true">View Historical Chart 📈</button>

    <!-- Historical NPS Scores Modal -->
    <a-modal
    v-model="is_modal_visible"
    :centered="true"
    :closable="false"
    :footer="null"
    :mask="true"
    :bodyStyle="{ padding: 0 }">
      <div class="chart-modal-container">

        <center style="margin-bottom: 20px">
        <a-dropdown>
          <a-menu slot="overlay" @click="changeChartPeriod">
            <a-menu-item key="Monthly">Monthly</a-menu-item>
            <!-- <a-menu-item key="Weekly">Weekly</a-menu-item> -->
            <a-menu-item key="Daily">Daily</a-menu-item>
          </a-menu>
          <a-button>
            {{ _.capitalize(chart_period) }} <a-icon type="down" />
          </a-button>
        </a-dropdown>
        </center>

        <NPSChartModal :chart_data="this.nps_chart_data" :width="700" :height="400" ref="nps_chart" />
      </div>
    </a-modal>

  </div>
</template>

<script>

import NPSDoughnut from '@/components/nps/NPSDoughnut.vue'
import NPSChartModal from '@/components/nps/NPSChartModal.vue'

import { nps_helper } from '../../store/nps_helper.js';

export default {
  name: 'NPSCard',
  components: {
    NPSDoughnut,
    NPSChartModal,
  },
  props: {
    nps_data: Object,
  },
  data() {
    return {
      is_modal_visible: false,
      chart_period: 'Monthly',
    }
  },
  computed: {

    nps_category_counts() {
      let values = [0,0,0];
      if (!this.nps_data) {
        return values;
      } else {
        let total_count = 0;
        let detractor_count = 0;
        let neutral_count = 0;
        let promoter_count = 0;
        _.forEach(this.nps_data, (scores_for_date, date) => {
          _.forEach(scores_for_date, (score_count, score_value) => {
            total_count++;
            if (score_value < 7) {
              detractor_count++;
            };
            if (score_value == 7 || score_value == 8) {
              neutral_count++;
            };
            if (score_value > 8) {
              promoter_count++;
            };
          });
        });
        return [promoter_count, neutral_count, detractor_count];
      };
    },

    nps_score() {
      let category_counts = this.nps_category_counts;
      let total_count = _.sum(category_counts);
      if (!total_count) {
        return '-';
      } else {
        let promoter_percentage = Math.floor(category_counts[0] / total_count * 100);
        let detractor_percentage = Math.floor(category_counts[2] / total_count * 100);
        return promoter_percentage - detractor_percentage;
      }
    },

    nps_answer_count() {
      return _.sum(this.nps_category_counts);
    },

    nps_chart_data() {
      let data;
      if (this.chart_period === 'Monthly') {
        data = nps_helper.getMonthlyNPS(this.nps_data);
      } else if (this.chart_period === 'Daily') {
        data = nps_helper.getDailyNPS(this.nps_data);
      };
      return data;
    }
  },

  methods: {

    changeChartPeriod(e) {
      this.chart_period = e.key;
      setTimeout(() => {
        this.$refs.nps_chart.render();
      }, 100);
    },

  }
}
</script>

<style scoped lang="scss">

.nps-score-container{
  display: block;
  margin: 0 auto;
  padding-top: 22px;
  padding-bottom: 22px;
  background-color: white;
  border-radius: 8px;
  height: 260px;
  width: 240px;
  transform: translateY(-30px);
  box-shadow: 0 0 8px 0 rgba(0,0,0,.08);
  h4{
    font-size: 15px;
    text-align: center;
    margin-bottom: 20px;
    font-weight: 600;
  }
  // .cdc-container{
  //   margin-left: 40px;
  // }
  p{
    font-family: "Montserrat", sans-serif;
  }
  .donut-container{
    height: 120px;
    width: 120px;
    display: block;
    margin: 0 auto;
    position: relative;
  }
  .nps-number-container{
    position: absolute;
      top: 29px;
    width: 100%;
    text-align: center;
    z-index: -1;
    .nps-number{
      font-size: 30px;
      color: black;
      font-weight: 600;
      margin: 0;
      letter-spacing: 1px;
    }
    .nps-number-subtitle{
      font-size: 12px;
      color: black;
      font-weight: 400;
      margin: 0;
      letter-spacing: 1px;
      transform: translateY(-5px);
    }
  }
  .chart-btn{
    display: block;
    font-weight: 600;
    background-color: rgb(250,250,251);
    padding: 5px 9px;
    margin: 0 auto;
    margin-top: 20px;
    border: 1px solid rgb(231,231,231);
    border-radius: 4px;
    transition: all 0.3s ease;
    cursor: pointer;
    &:hover{
      border-color: rgb(215,215,215);
    }
    &:active, &:focus{
      outline: none;
    }
  }
}

.chart-modal-container{
  padding: 20px;
}

</style>
